import React, { useState } from "react";
import api from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import NavBar from "../components/navbar/navbar";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [login, setLogin] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const res = await api.post("/auth/forgot-password", { login });
      setSuccess(res.data.message || "Un lien de réinitialisation a été envoyé à l'adresse email enregistrée lors de votre inscription.");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || t("forgot_password_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <NavBar />

      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-body-secondary">
        <style>{`
          .forgot-card { max-width: 420px; border-radius: 15px; }
          .form-control:focus { box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25); }
          .forgot-title { font-weight: 600; }
        `}</style>

        <div className="card forgot-card shadow p-4 border-0 bg-white w-100">
          <div className="text-center mb-4">
            <i className="bi bi-key-fill text-primary" style={{ fontSize: "2rem" }} />
            <h3 className="text-primary forgot-title mt-2">{t("forgot_password_title")}</h3>
            <p className="text-muted">{t("forgot_password_subtitle")}</p>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label" htmlFor="login">Votre identifiant (login)</label>
              <input
                id="login"
                type="text"
                className="form-control"
                placeholder="Entrez votre identifiant"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                required
                autoComplete="username"
              />
              <small className="text-muted">Un lien de réinitialisation sera envoyé à l'adresse email enregistrée lors de votre inscription.</small>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Envoi en cours...
                </>
              ) : (
                <>
                  <i className="bi bi-envelope me-2" />
                  Envoyer le lien de réinitialisation
                </>
              )}
            </button>
          </form>

          <div className="text-center mt-4">
            <p className="mb-0">
              <Link to="/login" className="text-decoration-none text-primary">
                <i className="bi bi-arrow-left me-1" />
                {t("back_to_login")}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

